import { Box, HStack, VStack } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { REPOSITORY } from '../../api/repository/Repository'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { CapacitacionAction } from './actions/CapacitacionAction'
import { GiftCardAction } from './actions/GiftCardAction'
import { ReferidoAction } from './actions/ReferidoAction'
import { SalaCunaAction } from './actions/SalaCunaAction'
import { SolicitudAction } from './actions/SolicitudAction'
import Banners from './Banners/Banners'
import CardsSection from './CardsSection/CardsSection'
import Indicador from './Indicador/Indicador'
import Locales from './Locales/Locales'
import Promotions from './Promotions/Promotions'
import StartModal from './StartModal'

export default function DashBoard() {
  const localData = REPOSITORY.local.company.getUserData()

  const [showModalStart, setShowModalStart] = useState(false)

  useEffect(() => {
    document.body.style.backgroundColor = '#f5f5f5'

    return () => {
      document.body.style.backgroundColor = ''
    }
  }, [])

  useEffect(() => {
    REPOSITORY.wsEmpresa.password
      .verifyPasswordChange_Modal()
      .then((success) => {
        setShowModalStart(success.data)
      })
      .catch(() => {})
  }, [])

  return (
    <VStack mb={50}>
      <StartModal
        isOpen={showModalStart}
        onClose={() => {
          setShowModalStart(false)
        }}
      />
      <Box alignSelf="self-start">
        <UnderlineHeading text="Información de valor" variant="h5" />
      </Box>
      <Box w="100vw">
        <Banners />
      </Box>
      <VStack w="100%" spacing="20px">
        <Box alignSelf="flex-start" mt={5}>
          <UnderlineHeading text="Indicadores" variant="h5" />
        </Box>
        <HStack w="100%">
          <CardsSection />
        </HStack>
        <HStack
          gap={5}
          w="100%"
          wrap="wrap"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Box flex={1}>
            <Box alignSelf="flex-start" mb={5}>
              <UnderlineHeading text="Promociones" variant="h5" />
            </Box>
            <Promotions />
          </Box>
          <Box flex={1}>
            <Box alignSelf="flex-start" mb={5}>
              <UnderlineHeading text="Locales Nuevos" variant="h5" />
            </Box>
            <Locales />
          </Box>
          <Box flex={1}>
            <Indicador />
            <Box alignItems="flex-start">
              <Box my={5}>
                <UnderlineHeading text="Accesos directos" variant="h5" />
              </Box>
              <HStack wrap="wrap" gap={3}>
                <ReferidoAction />
                <SolicitudAction />
                <CapacitacionAction />
              </HStack>
            </Box>
            <Box alignItems="flex-start">
              <Box my={5}>
                <UnderlineHeading text="Otros Productos" variant="h5" />
              </Box>
              <HStack wrap="wrap" gap={3}>
                <GiftCardAction />
                {!localData?.user?.bSalaCunaEmpresa && <SalaCunaAction />}
              </HStack>
            </Box>
          </Box>
        </HStack>
      </VStack>
    </VStack>
  )
}
